import { render, staticRenderFns } from "./more.vue?vue&type=template&id=29919b49&scoped=true&"
import script from "./more.vue?vue&type=script&lang=js&"
export * from "./more.vue?vue&type=script&lang=js&"
import style0 from "./more.vue?vue&type=style&index=0&id=29919b49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29919b49",
  null
  
)

export default component.exports